import script from "./icon-element-equal.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-element-equal.vue?vue&type=script&lang=ts&setup=true"

import "./icon-element-equal.vue?vue&type=style&index=0&id=09858b0b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09858b0b"]])

export default __exports__